export default `
  allCities {
    id
    currencyIsoCode
  }
  cities(cityIds: [$cityId]) {
    id
    areaId
    currencyIsoCode
    maximumPrice
    country {
      countryIsoCode
    }
    center {
      lng
      lat
    }
    limits {
      sw {
        lng
        lat
      }
      ne {
        lng
        lat
      }
    }
    minimumStaying
    otherCitiesInCountry
    allCities
  }
`;
